
import { Component, Vue } from 'vue-property-decorator'
import { TransTopReq } from '@/api/admin/risk'
import { SetToken, GetToken } from '@/libs/util'
@Component
export default class userOnline extends Vue {
  timer: any
  isAutoRefresh = GetToken().UserOnline != 0
  select = {
    app_list: <any>[],
    platform_list: [],
    type_list: [
      { value: 0, name: '全部' },
      { value: 1, name: '指定ID' },
      { value: 2, name: '真实名称' },
      { value: 3, name: '上级ID' },
      { value: 4, name: '注册IP' },
      { value: 5, name: '登陆IP' }
    ]
  }
  table = {
    total: 0,
    pageSizes: [10, 20, 30, 40],
    platid: 0,
    params: {
      app_id: 588,
      user_id: null,
      pack_no: '',
      type: null,
      page: 1,
      limit: 10
    },
    data: [],
    columns: [
      {
        key: 'user_id',
        align: 'center',
        minWidth: 50,
        render: (h, params) => {
          return h(
            'a',
            {
              on: {
                click: () => {
                  let query = {
                    back: 1,
                    user_id: params.row.user_id,
                    platid: this.table.platid,
                    app_id: this.table.params.app_id
                  }
                  this.goto('user_activePlayers', query)
                }
              }
            },
            params.row.user_id
          )
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '玩家ID', '显示对应信息玩家的ID')
      },
      {
        key: 'name',
        align: 'center',
        minWidth: 50,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '玩家昵称', '显示对应信息玩家的昵称')
      },
/*      {
        key: 'pid',
        align: 'center',
        minWidth: 50,
        render: (h, params) => {
          return h(
            'a',
            {
              on: {
                click: () => {
                  let query = {
                    back: 1,
                    user_id: params.row.pid,
                    platid: this.table.platid,
                    app_id: this.table.params.app_id
                  }
                  this.goto('user_activePlayers', query)
                }
              }
            },
            params.row.pid
          )
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '上级ID', '显示对应信息玩家的上级ID')
      },*/
      {
        key: 'pack_no',
        align: 'center',
        minWidth: 50,
        render: (h, params) =>
          h('span', params.row.pack_name + '(' + params.row.pack_no + ')'),
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '所属子商户',
            '显示对应信息玩家的所属子商户'
          )
      },
      {
        key: 'types',
        align: 'center',
        minWidth: 50,
        render: (h, params) => {
          let reg = ''
          let arr = params.row.types || []
          for (let i = 0; i < arr.length; i++) {
            reg += this.typeyuj(arr, i)
          }
          return h('span', reg)
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '预警类型',
            '显示对应玩家所触发的预警类型'
          )
      },
      {
        key: 'datas',
        align: 'center',
        minWidth: 50,
        render: (h, params) => {
          let arr = params.row.datas || []
          let str = arr.join(',')
          // for (let i = 0; i < arr.length; i++) {
          //   str += arr[i] + '；'
          // }
          return h('span', str)
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '预警来源',
            '显示对应玩家所触发的预警类型的阈值'
          )
      },
      {
        key: 'desc',
        align: 'center',
        minWidth: 50,
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '备注', '显示配置的备注信息')
      },
      {
        title: '操作',
        align: 'center',
        minWidth: 50,
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { margin: '2px', padding: '5px 20px' },
                on: {
                  click: () => {
                    this.setdescModal.typeid = 1
                    this.setdescModal.params.desc = params.row.desc
                    this.setdescModal.params.user_id = params.row.user_id
                    this.setdescModal.show = true
                  }
                }
              },
              '修改备注'
            )
          ])
        }
      }
    ]
  }
  waringModal = {
    show: false,
    total: 0,
    pageSizes: [10, 20, 30, 40],
    type_list: [
      { value: 1, name: '指定ID' },
      { value: 2, name: '真实名称' },
      { value: 3, name: '上级ID' },
      { value: 4, name: '注册IP' },
      { value: 5, name: '登陆IP' }
    ],
    data: [],
    params: {
      app_id: null,
      opt_type: 0,
      type: 1,
      id: 0,
      data: '',
      desc: '',
      page: 1,
      limit: 10
    },
    columns: [
      {
        key: 'type',
        align: 'center',
        render: (h, params) => {
          let str = this.select.type_list.filter(
            item => item.value == params.row.type
          )[0].name
          return h('span', str)
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '预警类型',
            '显示配置信息所设置的预警类型'
          )
      },
      {
        key: 'data',
        align: 'center',
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '预警来源',
            '显示配置信息所设置的预警类型的阈值'
          )
      },
      {
        key: 'update_time',
        align: 'center',
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '更新时间',
            '显示添加信息或最后一次修改信息的时间'
          )
      },
      {
        key: 'desc',
        align: 'center',
        renderHeader: (h, params) =>
          (this as any).renderHeader(h, '备注', '显示对应信息玩家的备注')
      },
      {
        key: 'opt',
        align: 'center',
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '操作账户ID',
            '显示修改该条信息的运营后台账户ID'
          )
      },
      {
        key: 'status',
        align: 'center',
        title: '管理',
        width: '200',
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: {
                  type: 'primary'
                },
                style: {
                  margin: '2px',
                  padding: '5px 20px'
                },
                on: {
                  click: () => {
                    this.setdescModal.typeid = 0
                    this.waringModal.params.desc = params.row.desc
                    this.waringModal.params.id = params.row.id
                    this.setdescModal.show = true
                  }
                }
              },
              '编辑备注'
            ),
            h(
              'Button',
              {
                props: {
                  type: 'error'
                },
                style: {
                  margin: '2px',
                  padding: '5px 20px'
                },
                on: {
                  click: () => {
                    this.waringModal.params.id = params.row.id
                    this.$Modal.confirm({
                      title: '删除预警信息',
                      content: '<p>是否确认删除该条信息？</p>',
                      onOk: () => {
                        this.SetEarlyWarningCfg(2)
                      }
                    })
                  }
                }
              },
              '删除'
            )
          ])
        }
      }
    ]
  }
  setdescModal = {
    show: false,
    typeid: 1,
    params: { app_id: null, user_id: null, desc: '' }
  }
  //跳转页面
  goto(path, query) {
    this.$router.push({
      name: path,
      query: query
    })
  }
  //透传接口请求参数 请求方法 请求参数
  returnParam(func, params) {
    return {
      mod: 'root',
      platid: this.table.platid,
      app_id: this.table.params.app_id,
      param: {
        _mod: 'manager',
        _func: func,
        _param: { ...params }
      }
    }
  }
  //选择平台
  updatePlatId() {
    this.table.params.app_id = (this as any).app_list.filter(
      (el: any) => el.platform == this.table.platid
    )[0].appid
    this.select.app_list = []
    ;(this as any).app_list.filter((el: any) => {
      if (el.platform == this.table.platid) {
        this.select.app_list.push(el)
      }
    })
  }
  // getAppInfo(item) {
  //     return ((this as any).app_list.find((el: any) => el.appid == item.app_id) ||{});
  // }
  //预警类型
  typeyuj(arr, i) {
    const type = arr[i]
    let str = ''
    if (type == 1) {
      str += '指定ID'
    } else if (type == 2) {
      str += '真实名称'
    } else if (type == 3) {
      str += '上级ID'
    } else if (type == 4) {
      str += '注册IP'
    } else if (type == 5) {
      str += '登陆IP'
    }

    if (i < arr.length - 1) {
      return str + ','
    } else {
      return str
    }
  }

  // 关闭备注弹框
  closeSetdescModal() {
    this.waringModal.params.desc = ''
    this.setdescModal.show = false
  }

  //修改备注
  yesSetEarly() {
    if (this.setdescModal.typeid) {
      this.SetEarlyWarningUserDesc()
    } else {
      this.SetEarlyWarningCfg(1)
    }
  }
  //表单修改备注
  SetEarlyWarningUserDesc() {
    let params = {
      app_id: this.table.params.app_id,
      user_id: Number(this.setdescModal.params.user_id),
      desc: this.waringModal.params.desc
    }
    TransTopReq(this.returnParam('SetEarlyWarningUserDesc', params)).then(
      res => {
        this.$Message.success('修改成功')
        this.GetEarlyWarningUser()
        this.waringModal.params.desc = ''
        this.setdescModal.show = false
      }
    )
  }
  //添加
  SetEarlyWarningCfg(type) {
    if (type == 0) {
      if (!this.waringModal.params.data)
        return this.$Message.warning('请输入预警来源信息')
    }
    let params = {
      app_id: this.table.params.app_id,
      opt_type: type,
      id: this.waringModal.params.id,
      type: this.waringModal.params.type,
      data: this.waringModal.params.data,
      desc: this.waringModal.params.desc
    }
    TransTopReq(this.returnParam('SetEarlyWarningCfg', params)).then(res => {
      if (type == 0) {
        this.$Message.success('添加成功')
        this.waringModal.params.desc = ''
        this.waringModal.params.data = ''
      } else if (type == 1) {
        this.$Message.success('修改成功')
        this.setdescModal.show = false
        this.waringModal.params.desc = ''
      } else if (type == 2) {
        this.$Message.success('删除成功')
      }
      this.GetEarlyWarningCfg()
      this.GetEarlyWarningUser()
    })
  }

  //打开预警列表
  openWaringModal() {
    this.GetEarlyWarningCfg(1)
    this.waringModal.show = true
  }
  //获取列表
  GetEarlyWarningCfg(num?) {
    if (num) {
      this.waringModal.params.page = 1
    }
    let params = {
      ...this.waringModal.params,
      app_id: this.table.params.app_id
    }
    TransTopReq(this.returnParam('GetEarlyWarningCfg', params)).then(res => {
      this.waringModal.data = res._param.data || []
      this.waringModal.total = res._param.total
    })
  }
  limitchangeWaringModal(limit) {
    this.waringModal.params.page = 1
    this.waringModal.params.limit = limit
    this.GetEarlyWarningCfg()
  }
  pagechangeWaringModal(page) {
    this.waringModal.params.page = page
    this.GetEarlyWarningCfg()
  }

  limitchange(limit) {
    this.table.params.page = 1
    this.table.params.limit = limit
    this.GetEarlyWarningUser()
  }
  pagechange(page) {
    this.table.params.page = page
    this.GetEarlyWarningUser()
  }
  //获取列表
  GetEarlyWarningUser() {
    let params = {
      ...this.table.params,
      user_id: Number(this.table.params.user_id),
      pack_no:
        this.table.params.pack_no.length == 0
          ? -1
          : Number(this.table.params.pack_no),
      type: this.table.params.type == null ? 0 : this.table.params.type
    }
    TransTopReq(this.returnParam('GetEarlyWarningUser', params)).then(res => {
      this.table.data = res._param.data || []
      this.table.total = res._param.total
    })
  }
  onSwitch(status) {
    SetToken({ UserOnline: (status && 1) || 0 })
    if (status) {
      this.startRefreshTimer()
    } else {
      this.clearRefreshTimer()
    }
  }
  startRefreshTimer() {
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(() => {
        this.GetEarlyWarningUser()
      }, 10000)
    }
  }
  clearRefreshTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
  mounted() {
    if (this.isAutoRefresh) {
      this.startRefreshTimer()
    }
  }
  initFunc() {
    let platid = (this as any).getinitPlatId()
    this.table.platid = platid
    let app = (this as any).app_list.find((el: any) => el.platform == platid)
    this.select.app_list = []
    ;(this as any).app_list.filter((el: any) => {
      if (el.platform == platid) {
        this.select.app_list.push(el)
      }
    })
    this.table.params.app_id = app ? app.appid : 0
    this.GetEarlyWarningUser()
  }
  created() {
    this.initFunc()
  }
}
